var $ce77af30fc9a6e63$exports = {};
const $ce77af30fc9a6e63$var$hamburger = document.querySelector('.hamburger');
const $ce77af30fc9a6e63$var$nav = document.querySelector('.navigation__list');
const $ce77af30fc9a6e63$var$pageBody = document.querySelector('body');
const $ce77af30fc9a6e63$var$submenu = document.querySelector('.submenu');
const $ce77af30fc9a6e63$var$submenuTrigger = document.querySelector('.navigation__list__submenu');
// const arrow = submenuTrigger.querySelector('span')
$ce77af30fc9a6e63$var$hamburger.addEventListener('click', ()=>{
    $ce77af30fc9a6e63$var$nav.classList.toggle('navigation__list--active');
    $ce77af30fc9a6e63$var$hamburger.classList.toggle('active');
    if ($ce77af30fc9a6e63$var$nav.classList.contains('navigation__list--active')) $ce77af30fc9a6e63$var$pageBody.style.overflowY = 'hidden';
    else $ce77af30fc9a6e63$var$pageBody.style.overflowY = 'auto';
});
// submenuTrigger.addEventListener('click', () => {
//     submenu.classList.toggle('submenu__active');
//     // arrow.classList.toggle('navigation__list__submenu__span--active');
// })
document.addEventListener('click', (event)=>{
    const isClickInsideSubmenuTrigger = $ce77af30fc9a6e63$var$submenuTrigger.contains(event.target);
    if (!isClickInsideSubmenuTrigger && $ce77af30fc9a6e63$var$submenu.classList.contains('submenu__active')) {
        $ce77af30fc9a6e63$var$submenu.classList.remove('submenu__active');
        $ce77af30fc9a6e63$var$submenuTrigger.classList.remove('navigation__list__submenu--active');
    }
});


//# sourceMappingURL=wypozyczalniawegrzce.1b12f0e5.js.map
